import axios from "axios";

export const pkiAxios = axios.create();

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const entraGuestService = {
    submitGuestInvitationRequest: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}entra/submitRequest`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
    viewRequests: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}entra/viewRequests`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },

    revokeAccess: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}entra/revokeAccess`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },

    resendInvite: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}entra/resendInvite`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },

    resetMfa: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}entra/resetMfa`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },

    submitRequest: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}entra/submitRequest`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },

    validateRequest: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}entra/validateRequest`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },

    refreshUserData: async (payload) => {
        try {
            const response = await axios.post(`${API_ENDPOINT}entra/refreshUserData`, payload);
            return response.data;
        } catch (error) {
            console.error("Error fetching form data:", error);
            throw error;
        }
    },
};

export default entraGuestService;